var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2053 24.5V9.79995H40.5893V24.5H11.2053ZM37.7909 32.2H36.3915V25.9H37.7909V32.2ZM30.7947 25.9H32.1939V27.3C32.1939 27.6866 32.5071 28 32.8935 28C33.2798 28 33.5931 27.6866 33.5931 27.3V25.9H34.9923V32.2H30.7947V25.9ZM40.5893 5.59995V8.39995H11.2053V5.59995H40.5893ZM41.2889 4.19995H10.5057C10.1194 4.19995 9.80609 4.51329 9.80609 4.89995V25.2C9.80609 25.5866 10.1194 25.9 10.5057 25.9H29.3953V32.2H26.597V33.6H37.7909V35H26.597V36.4H38.4905C38.8767 36.4 39.1901 36.0866 39.1901 35.7V25.9H41.2889C41.6753 25.9 41.9885 25.5866 41.9885 25.2V4.89995C41.9885 4.51329 41.6753 4.19995 41.2889 4.19995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.216 33.6L10.7106 34.0948C10.8419 34.2261 11.0199 34.3 11.2053 34.3H14.0038C14.1894 34.3 14.3672 34.2261 14.4985 34.0948L14.9931 33.6H23.6785C23.3898 34.4149 22.6116 35 21.6996 35H3.50951C2.59744 35 1.81926 34.4149 1.53063 33.6H10.216ZM3.50951 36.4H21.6996C23.6284 36.4 25.1978 34.8299 25.1978 32.9C25.1978 32.5134 24.8844 32.2 24.4982 32.2H21.6996V27.3H20.3004V32.2H4.9087V20.3H8.40687V18.9H4.2091C3.82285 18.9 3.50951 19.2134 3.50951 19.6V32.2H0.71113C0.324672 32.2 0.0115356 32.5134 0.0115356 32.9C0.0115356 34.8299 1.58086 36.4 3.50951 36.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6047 7.70005C12.9909 7.70005 13.3042 7.38671 13.3042 7.00005C13.3042 6.61339 12.9909 6.30005 12.6047 6.30005C12.2182 6.30005 11.9051 6.61339 11.9051 7.00005C11.9051 7.38671 12.2182 7.70005 12.6047 7.70005Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7034 7.70005C15.0899 7.70005 15.403 7.38671 15.403 7.00005C15.403 6.61339 15.0899 6.30005 14.7034 6.30005C14.317 6.30005 14.0038 6.61339 14.0038 7.00005C14.0038 7.38671 14.317 7.70005 14.7034 7.70005Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8022 7.70005C17.1887 7.70005 17.5018 7.38671 17.5018 7.00005C17.5018 6.61339 17.1887 6.30005 16.8022 6.30005C16.416 6.30005 16.1026 6.61339 16.1026 7.00005C16.1026 7.38671 16.416 7.70005 16.8022 7.70005Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6046 12.6H14.7034V11.2H12.6046V12.6Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6996 11.2H16.8022V12.6H21.6996V11.2Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0988 12.6H25.1978V11.2H23.0988V12.6Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6046 16.1H14.7034V14.7H12.6046V16.1Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6008 14.7H16.8022V16.1H19.6008V14.7Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.1H25.1978V14.7H21V16.1Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6046 19.6H14.7034V18.2H12.6046V19.6Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8022 19.6H25.1977V18.2H16.8022V19.6Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6046 23.1H14.7034V21.7H12.6046V23.1Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8022 23.1H19.6008V21.7H16.8022V23.1Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23.1H25.1978V21.7H21V23.1Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6003 14.2052L27.5015 16.3052C27.2283 16.5786 27.2283 17.0216 27.5015 17.295L29.6003 19.395L30.5898 18.4052L28.9854 16.8L30.5898 15.195L29.6003 14.2052Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1865 14.2052L35.1973 15.195L36.8014 16.8L35.1973 18.4052L36.1865 19.395L38.2855 17.295C38.5587 17.0216 38.5587 16.5786 38.2855 16.3052L36.1865 14.2052Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8306 20.7785L32.1581 21.2214L34.9565 12.8216L33.629 12.3787L30.8306 20.7785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.d2084c1ee5ab245d3177a7b8b94399ea.svg";
export { ForwardRef as ReactComponent };